import { useTranslation } from 'react-i18next'

interface AdminCredentialsFieldsProps {
  adminUsername: string
  adminPassword: string
  setAdminUsername: (value: string) => void
  setAdminPassword: (value: string) => void
}

export function AdminCredentialsFields({
  adminUsername,
  adminPassword,
  setAdminUsername,
  setAdminPassword,
}: AdminCredentialsFieldsProps): React.ReactElement {
  const { t } = useTranslation('admin')
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <div>
        <label className="mb-1 block text-sm font-medium text-stone-700 dark:text-stone-300">
          {t('velociraptorSettings.install.adminUsername')}
        </label>
        <input
          type="text"
          value={adminUsername}
          onChange={(ev) => {
            setAdminUsername(ev.target.value)
          }}
          className="w-full rounded-lg border border-stone-300 bg-white px-3 py-2 text-stone-900 dark:border-stone-600 dark:bg-stone-700 dark:text-stone-100"
          placeholder={t('velociraptorSettings.placeholders.adminUsername')}
        />
      </div>
      <div>
        <label className="mb-1 block text-sm font-medium text-stone-700 dark:text-stone-300">
          {t('velociraptorSettings.install.adminPassword')}
        </label>
        <input
          type="password"
          value={adminPassword}
          onChange={(ev) => {
            setAdminPassword(ev.target.value)
          }}
          className="w-full rounded-lg border border-stone-300 bg-white px-3 py-2 text-stone-900 dark:border-stone-600 dark:bg-stone-700 dark:text-stone-100"
          placeholder={t('velociraptorSettings.placeholders.adminPassword')}
        />
      </div>
    </div>
  )
}
